import * as THREE from "three"; 
import LpApp from "../LpApp.js";

export default class Environment
{
    constructor()
    {
        console.log("Created Environment.");
        this.lpApp = new LpApp();
        this.Resources = this.lpApp.Resources;

        this.SetSunLight();
        this.SetEnvironmentMap();
        this.SetDebugUI();
    }

    SetSunLight()
    {
        this.SunLight = new THREE.DirectionalLight('#ffffff', 4)
        this.SunLight.castShadow = true
        this.SunLight.shadow.camera.far = 15
        this.SunLight.shadow.mapSize.set(1024, 1024)
        this.SunLight.shadow.normalBias = 0.05
        this.SunLight.position.set(3.5, 2, - 1.25)
        
        this.lpApp.Scene.add(this.SunLight);
    }

    SetEnvironmentMap()
    {
        this.EnvironmentMap = {};
        this.EnvironmentMap.intensity = 0.4;
        this.EnvironmentMap.texture = this.Resources.items.environmentMapTexture;
        this.EnvironmentMap.texture.colorSpace = THREE.SRGBColorSpace;
        this.lpApp.Scene.environment = this.EnvironmentMap.texture;

        this.EnvironmentMap.UpdateMaterial = () =>
        {
            this.lpApp.Scene.traverse((child) =>
            {
                //console.log(child);
                if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial)
                {
                    child.material.envMap = this.EnvironmentMap.texture;
                    child.material.envMapIntensity = this.EnvironmentMap.intensity;
                    child.material.needsUpdate = true;
                }
            });
        };

        this.EnvironmentMap.UpdateMaterial();
    }

    SetDebugUI() {
        const debugUI = this.lpApp.DebugUI;
        if (debugUI.active) {
            const folder = debugUI.ui.addFolder('Environment');
            folder.add(this.EnvironmentMap, 'intensity').name('Env Intensity').min(0).max(4).step(0.001).onChange(this.EnvironmentMap.UpdateMaterial);

            folder.add(this.SunLight, 'intensity').name('Light Intensity').min(0).max(10).step(0.001).onChange(this.EnvironmentMap.UpdateMaterial);

        }
    }
}